export const DEFAULT_PALLETE = [
  '#003f5c', '#2f4b7c', '#665191', '#a05195', '#d45087', '#f95d6a',
  '#ff7c43', '#ffa600', '#c23531', '#2f4554', '#61a0a8', '#d48265',
  '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570',
  '#c4ccd3'
]
